import { createApp } from 'vue'
import App from './App.vue'
import { MotionPlugin } from '@vueuse/motion'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import '../src/assets/sass/styles.scss'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(fas, fab)

loadFonts()

createApp(App)
  .use(vuetify)
  .use(MotionPlugin)
  .component('fa', FontAwesomeIcon)
  .mount('#app')
